export const THEME_BUILDER_API_URL = 'https://wpp-app-theme-builder-api-ch-elektra.os-dev.io' || 'http://localhost:8080'
